import { useQuery } from '@apollo/client';
import { GET_USER_LICENCES } from '../../graphql/queries/user/user';

const useGetUserLicences = () => {
  const { data, loading, error } = useQuery(GET_USER_LICENCES);
  return { data, loading, error };
};

export default useGetUserLicences;
